// @unocss-include
import * as React from 'react';
function useMergedRef(...refs) {
    return React.useCallback((element) => {
        for (let i = 0; i < refs.length; i++) {
            const ref = refs[i];
            if (typeof ref === 'function')
                ref(element);
            else if (ref && typeof ref === 'object')
                ref.current = element;
        }
    }, refs);
}
export default useMergedRef;
//# sourceMappingURL=useMergedRef.js.map